import styled from 'styled-components';

import TotalModalWrapper from '../../../../Share/Normal/TotalModalWrapper';
import { useLanguage } from '../../../../../Context/LanguageContext';
import { useTheme } from '../../../../../Context/ThemeContext';

export default function LessonReserveHistoryDeleteModal(props) {
  const { exitClickFn, deleteClickFn } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();

  function exitClick() {
    exitClickFn();
  }

  function deleteClick() {
    deleteClickFn();
    exitClickFn();
  }

  return (
    <TotalModalWrapper>
      <ModalView $isDark={isDark}>
        <Title>{t('memberDetail.lessonDeleteTitle')}</Title>
        <TextWrapper>
          <Explanation>{t('memberDetail.lessonDeleteDesc1')}</Explanation>
          <Explanation>{t('memberDetail.lessonDeleteDesc2')}</Explanation>
        </TextWrapper>
        <ButtonWrapper>
          <ExitButton onClick={exitClick}>{t('memberDetail.modalCancel')}</ExitButton>
          <CancelButton onClick={deleteClick}>{t('memberDetail.modalProceed')}</CancelButton>
        </ButtonWrapper>
      </ModalView>
    </TotalModalWrapper>
  )
}

const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  padding: 20px;

  box-sizing: border-box;
  width: 339px;

  gap: 20px;

  border-radius: 10px;
  // box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(0, 0, 0, 0.1)'};
  background-color: ${props => props.theme.subBackground};
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  width: 100%;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 38px;

  border: 1px solid ${props => props.theme.buttonFill};
  border-radius: 10px;
  background-color: ${props => props.theme.buttonFill};

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.text};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
      border: 1px solid ${props => props.theme.text};
      color: ${props => props.theme.text};
    }
  }
`;

const CancelButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.pointRed};

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;
